
import { Options, Vue } from "vue-class-component";
import { mapGetters } from "vuex";
@Options({
  computed: {
    ...mapGetters(["isHasNoHeader"])
  }
})
export default class ContentHeader extends Vue {}
